import React from 'react';
import SummaryGrid from '../SummaryGrid';
export default React.memo(SummaryGrid);